var req = require("!!/__w/30/s/node_modules/pug-loader/index.js!/__w/30/s/src/app/dfu-progress-container/dfu-progress/dfu-progress.component.pug");
module.exports = (req['default'] || req).apply(req, [])